import { MobileAppFlair } from 'types/graphql';

export const FLAIR_VIEWBOX = '0 0 100 30';

/** SVG path for a section-edge flair shape in `FLAIR_VIEWBOX` coordinates. */
export function getFlairPath(flairType: MobileAppFlair): string {
  switch (flairType) {
    case MobileAppFlair.angled:
      return 'M0 14 L100 0 L100 30 L0 30 Z';
    case MobileAppFlair.curved:
      return 'M0 20 Q50 0 100 20 L100 30 L0 30 Z';
    case MobileAppFlair.jagged:
      return 'M0 30 L0 12 L3 0 L6 12 L9 0 L13 12 L16 0 L19 12 L22 0 L25 12 L28 0 L31 12 L34 0 L38 12 L41 0 L44 12 L47 0 L50 12 L53 0 L56 12 L59 0 L63 12 L66 0 L69 12 L72 0 L75 12 L78 0 L81 12 L84 0 L88 12 L91 0 L94 12 L97 0 L100 12 L100 30 Z';
    case MobileAppFlair.wavy:
      return 'M0 15 C16 0 33 30 50 15 C66 0 83 30 100 15 L100 30 L0 30 Z';
    case MobileAppFlair.none:
      return '';
    default: {
      return '';
    }
  }
}

/**
 * Clip path that gives a button the flair shape. Unlike `getFlairPath` -- which decorates only the
 * top and bottom edge of a full-width section -- this reshapes a small square button all the way
 * around, so the shapes are their own closed outlines rather than the section paths scaled down.
 */
export function getButtonClipPath(flair: MobileAppFlair | undefined): string {
  switch (flair) {
    case MobileAppFlair.angled:
      return 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)';
    case MobileAppFlair.jagged:
      return 'polygon(50% 0%, 60% 13%, 75% 7%, 77% 23%, 93% 25%, 87% 40%, 100% 50%, 87% 60%, 93% 75%, 77% 77%, 75% 93%, 60% 87%, 50% 100%, 40% 87%, 25% 93%, 23% 77%, 7% 75%, 13% 60%, 0% 50%, 13% 40%, 7% 25%, 23% 23%, 25% 7%, 40% 13%)';
    case MobileAppFlair.wavy:
      return 'polygon(96% 50%, 99% 56%, 98% 63%, 92% 68%, 87% 71%, 84% 76%, 83% 83%, 80% 89%, 75% 93%, 68% 92%, 61% 91%, 56% 92%, 50% 96%, 44% 99%, 37% 98%, 32% 92%, 29% 87%, 24% 84%, 17% 83%, 11% 80%, 7% 75%, 8% 68%, 9% 61%, 8% 56%, 4% 50%, 1% 44%, 2% 37%, 8% 32%, 13% 29%, 16% 24%, 17% 17%, 20% 11%, 25% 7%, 32% 8%, 39% 9%, 44% 8%, 50% 4%, 56% 1%, 63% 2%, 68% 8%, 71% 13%, 76% 16%, 83% 17%, 89% 20%, 93% 25%, 92% 32%, 91% 39%, 92% 44%)';
    case MobileAppFlair.curved:
    case MobileAppFlair.none:
    case undefined:
      return '';
    default: {
      return '';
    }
  }
}
